import React from 'react';
import styles from './FullWidthImage.module.css';

const FullWidthImage = ({ imageSrc, altText = "LifeInPXL showcase" }) => {
  return (
    <section className={styles["full-width-image"]}>
      <img 
        src={imageSrc} 
        alt={altText} 
        className={styles["full-image"]}
      />
    </section>
  );
};

export default FullWidthImage;

